import getApi from '../../api'
import { deserializeOrdoclicUrlResponse, OrdoclicUrlResource } from './mapper/ordoclicUrl.mapper'

export const getConsultationOrdoclicUrl = () =>
  getApi()
    .post<OrdoclicUrlResource>('/external_eprescription/init')
    .then(deserializeOrdoclicUrlResponse)
